<template>
  <form v-on:submit="submit" id="badgeCreateForm" novalidate>
    <div class="form-group">
      <label for="badgeName">Badge name</label>
      <input
        v-model="badgeData.name"
        type="text"
        class="form-control"
        id="badgeName"
        placeholder="Badge name"
        required
      />
      <div class="valid-feedback">Looks good!</div>
    </div>

    <div class="form-group">
      <label for="description">Description</label>
      <input
        v-model="badgeData.description"
        type="text"
        class="form-control"
        id="description"
        placeholder="Badge description"
        required
      />
      <div class="valid-feedback">Looks good!</div>
    </div>

    <div class="form-group">
      <label for="files">Select badge image</label>
      <div class="custom-file">
        <input
          type="file"
          class="custom-file-input"
          id="files"
          name="file"
          ref="uploadInput"
          :multiple="false"
          required
          @change="detectFiles($event)"
        />
        <label v-if="badgeImage" class="custom-file-label" for="files">
          <b>Selected {{badgeImage.name}}</b>
        </label>
        <label v-else class="custom-file-label" for="files">Select an image less then 10MB</label>
        <div class="invalid-feedback">You must select a file to upload before submitting.</div>
      </div>
    </div>

    <button class="btn btn-warning" type="submit">Create Badge</button>
  </form>
</template>

<script>
window.$ = window.jQuery = require("jquery");
import firebase from "@/config/firebase.js";
import { firestorage } from "@/config/firebase.js";
require("bootstrap/dist/js/bootstrap.js");

export default {
  name: "badgecreateform",
  data() {
    return {
      progressUpload: 0,
      badgeImage: null,
      badgeData: {
        name: "",
        description: ""
      }
    };
  },
  methods: {
    submit: function(event) {
      const self = this;
      const form = document.getElementById("badgeCreateForm");

      event.preventDefault();
      event.stopPropagation();

      form.classList.add("was-validated");

      if (form.checkValidity()) {
        firebase
          .firestore()
          .collection("badges")
          .add(this.badgeData)
          .then(ref => {
            if (ref.id) {
              self.uploadBadgeImage(ref.id);

              $("#badgeCreate").modal("hide");
            }
          })
          .catch(function(error) {
            console.error(error);
          });
      }
    },
    detectFiles(event) {
      const fileList = event.target.files || event.dataTransfer.files;
      const file = fileList[0];

      if (file.size < 10 * 1024 * 1024 && file.type.substring(0, 6) === "image/") {
        //console.log("GOOD FILE " + file);
        this.badgeImage = file;
      } else {
        //console.log("BAD FILE " + file);
      }
    },
    uploadBadgeImage(badgeId) {
      const file = this.badgeImage;

      firestorage
        .ref(`badges/${badgeId}/images/badge.png`)
        .put(file)
        .catch(function(error) {
          console.error(error);
        });
    }
  }
};
</script>

<style scoped>
</style>
